import React from "react";

export default function PrintContent({
  children,
  orientation = "portrait",
  customCss = "",
}) {
  const PRINT_STYLES = `
  @media print {
    .menu, .navbar, .notifications, .main-content *:not(.print-content, .print-content *) {
      display: none !important;
    }
    .print-content {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      print-color-adjust: exact;
      -webkit-print-color-adjust: exact;
    }
    ${customCss}
    @page {
      size: A4 ${orientation};
      margin-bottom: 3mm;
      margin-left: 5mm;
      margin-right: 7mm;
    }
  }
`;
  return (
    <div className="print-content">
      <style>{PRINT_STYLES}</style>
      {children}
    </div>
  );
}
